import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

// import other components within the same project here
import Config from "../Config.jsx";

import Localization from "../Localization.jsx"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  GridList,
  GridListTile,
  GridListTileBar,
  Button,
} from '@material-ui/core';

import {
  grey,
} from '@material-ui/core/colors'

class StagePicker extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      targetStageId: "",
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleStageClicked(stageID) {
    this.setState({
      targetStageId: stageID,
    })
    this.state.targetStageId = stageID;

    this.onStagePicked();
    this.handleClose();
  }

  onStagePicked() {
    if (this.props.parent.onStagePicked) {
      this.props.parent.onStagePicked(this.state.targetStageId);
    }
  }

  render() {
    let stageList = [];
    if (this.props.root.refs.stageViewerPage) {
      stageList = this.props.root.refs.stageViewerPage.state.stageList;
    }

    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth={true}
          maxWidth={'md'}
        >
          <DialogTitle>
            All Stages
          </DialogTitle>
          <DialogContent>
            <GridList
              cellHeight={200}
              style={{flex:"1", overflow:'auto'}}
            >
              {stageList.map(row => {
                let tn_path = (row['movie_list'][0] != null? Config.BASE_PATH() + row['movie_list'][0]['tn_path'] : "");
                return (
                  <GridListTile
                    key={row['id']}
                    onClick={()=>this.handleStageClicked(row['id'])}
                    style={{cursor:'pointer'}}
                  >
                    <If condition={tn_path == ""}>
                      <Then>
                        <div style={{backgroundColor:grey[200], width:'100%', height:'100%'}}/>
                      </Then>
                    </If>
                    <img src={tn_path}/>
                    <GridListTileBar
                      title={row['stage_name']}
                      subtitle={row['playback_list'].length + " elements"}
                    />
                  </GridListTile>
                );
              })}
            </GridList>
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.handleClose}>
              {Localization.strings.CANCEL}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default StagePicker;
